import React from 'react';
import PropTypes from 'prop-types';

const SelectOptions = ({ options }) => {
  if (!options) return null;
  if (options?.length && Array.isArray(options)) {
    return (
      <>
        {options?.map((option, index) => (
          <option key={option} value={index}>
            {option}
          </option>
        ))}
      </>
    );
  }
  if (!Array.isArray(options) && typeof options === 'object') {
    const prepareOpts = Object?.entries(options)?.map(([value, label]) => ({ value, label }));
    return (
      <>
        {prepareOpts?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </>
    );
  }
  return null;
};

SelectOptions.propTypes = {
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default SelectOptions;
